import React, {Component, ReactElement} from 'react'
import PreformattedDiv from '../../../styledComponents/PreformattedDiv'
import {Messages} from '../../../Messages'
import {StyledSecondaryButton} from '../../../styledComponents/Button'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {Nullable} from '../../../app/TypeHelpers'
import {WideMainContainer} from '../../../styledComponents/ContentsArea'
import styled from 'styled-components'
import NotInterestedIcon from '@mui/icons-material/NotInterested'
import {Colors} from '../../../styledComponents/Constants'
import {Box} from '@mui/material'
import {Location} from 'react-router-dom'
import withStyles from '@mui/styles/withStyles'

interface Props {
    location: Location
}

class NatResidentNotFoundErrorPage extends Component<Props & ResidentPagePropsSet> {
    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props)
    }

    render(): Nullable<ReactElement> {
        // デフォルトタイトルの設定
        let title = 'お探しのページが見つかりませんでした'
        if (this.props.location.state && this.props.location.state.title) {
            // 遷移元から指定されたメッセージがあれば、設定
            title = this.props.location.state.title
        }

        // デフォルトメッセージの設定
        let message = Messages.ESYCC0026.toString()
        if (this.props.location.state && this.props.location.state.message) {
            // 遷移元から指定されたメッセージがあれば、設定
            message = this.props.location.state.message
        }

        return <>
            <ContentArea>
                <ErrorTitleArea>
                    <StyledNotInterestedIcon/>
                    <ErrorTitle>
                        {title}。
                    </ErrorTitle>
                </ErrorTitleArea>
                <Box height={'32px'}/>
                <WhiteArea>
                    <PreformattedDiv>{message}</PreformattedDiv>
                </WhiteArea>
                <Box height={'60px'}/>
                <StyledSecondaryButton
                    onClick={() => this.props.navigate(
                        '/resident/mypage',
                    )}>
                    ホームへ戻る
                </StyledSecondaryButton>
            </ContentArea>
        </>
    }
}

export default createResidentPage(NatResidentNotFoundErrorPage)

const ContentArea = styled.div`
  margin: auto;
  padding: 15px 0;
  max-width: 738px;
`

const ErrorTitleArea = styled.div`
  display: flex;
  align-items: center;
`

const StyledNotInterestedIcon = withStyles({
    root: {
        fontSize: '48px',
        color: '#b0b0b0',
    },
})(NotInterestedIcon)

const ErrorTitle = styled.div`
  margin-left: 8px;
  font-size: 20px;
  font-weight: bold;
  color: ${Colors.AccentDark};
`

const WhiteArea = styled(WideMainContainer)`
  padding: 15px;
`
